import { createFileRoute } from '@tanstack/react-router'
import AssetOverview from 'Asset/components/asset/Sections/AssetOverview'

export const Route = createFileRoute('/assets/$id/')({
    component: AssetOverview,
})
